import React from 'react';
import FirstIcon from '../assets/goto-first_100x100.svg';
import LastIcon from '../assets/goto-last_100x100.svg';

const BackNextButtonContainer = ({ onToFirstClick, onBackClick, onNextClick, onToLastClick }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <div className="small_img_btn-13 margin_left" onClick={onToFirstClick}> <img src={FirstIcon} alt="First" /> </div>
      <div className="small_btn-13  margin_left" onClick={onBackClick}>Back</div>
      <div className="small_btn-13 margin_left" onClick={onNextClick}>Next</div>
      <div className="small_img_btn-13" onClick={onToLastClick}> <img className=" margin_left" src={LastIcon} alt="Last" /> </div>
    </div>
  );
};

export default BackNextButtonContainer;
